$(function() {
    $("#accordion .scroll-down").click(function() {
        $('html, body').animate({
            scrollTop: $(".okeReviews-widget-holder").offset().top
        }, 2000);
    });

    /*** Mega Menu ***/

    $('.main-left ul li:first-child ul.sub-menu').remove();
    $('.main-left > ul > li:first-child').addClass('toggle-mega');
  	// toggle mega menu on click
  	$('.main-left > ul > li.toggle-mega > a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.main-left > ul > li.open').removeClass('open');
        $('.main-right > ul > li.open').removeClass('open');
        $(this).parent().toggleClass('open');
        $('.product-mega-menu').slideToggle();
        $('.after-mega').toggle();
        $('.product-mega-menu a:first').focus();
    });
  	//at end of products menu, go to brand story
  	$('.product-mega-menu .mega:last-child li:last-child > a').on('keydown', function(e) {
      	var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode == '9') {
          e.preventDefault();
          $('.main-left > ul > li:nth-child(2) > a').focus();
          $('.main-left > ul > li.toggle-mega').removeClass('open');
          $('.product-mega-menu').slideToggle();
        }
  	});
  
  	/*** Main Menu - Not Mega Menu ***/
  
  	$('ul.sub-menu').prev('a').addClass('has-children');
    $('ul.grandchild').prev('a').addClass('has-grandchildren');
  	//open regular menu items on click if they have children - left side
  	$('.main-left > ul > li:not(".toggle-mega") > a.has-children').on('click', function(e) {
    	e.preventDefault();
    	e.stopPropagation();
        //close any other menus
        $('.main-left > ul > li.open').removeClass('open');
        $('.main-right > ul > li.open').removeClass('open');
        $('.main-left > ul > li.toggle-mega').removeClass('open');
        $('.product-mega-menu').slideUp();
    	$(this).parent().toggleClass('open');
  	});
  	//open regular menu items on click if they have children - right side
  	$('.main-right > ul > li > a.has-children').on('click', function(e) {
    	e.preventDefault();
    	e.stopPropagation();
        //close any other open menus
        $('.main-left > ul > li.open').removeClass('open');
        $('.main-right > ul > li.open').removeClass('open');
        $('.main-left > ul > li.toggle-mega').removeClass('open');
        $('.product-mega-menu').slideUp();
    	$(this).parent().toggleClass('open');
  	});
  
  	/*** Dropdown and Filters ***/
  
  	// is this still in use??
    var dropdown = $('header .dropdown-menu');
    dropdown.each(function() {
        $(this).on('click', function(e) {
          	e.preventDefault();
          	e.stopPropagaion();
            $(this).parent().find('a').toggleClass('open');
        });
    });
    $('#c_filter .card').each(function() {
        if ($(this).find('.card-block').is(':empty')) {
            $(this).hide();
        }
    });

    /*** Navbar Toggler ***/
  
  	//is this still in use??
    var navvy = $('header .navbar-toggler');
    navvy.click(function() {
        $('header').toggleClass('relative');
        $('body').toggleClass('no-padding');
    });
    $(".lm-item").slice(0, 6).show();
    if ($(".lm-item:hidden").length > 0) {
        $("#load-more").css('display', 'block');
    }
    $("#load-more").on('click', function(e) {
        e.preventDefault();
        $(".lm-item:hidden").slice(0, 6).fadeIn();
        if ($(".lm-item:hidden").length == 0) {
            $("#load-more").hide();
        }
    });
    $(".lm-item-search").slice(0, 6).show();
    if ($(".lm-item-search:hidden").length > 0) {
        $("#load-more-search").css('display', 'block');
    }
    $("#load-more-search").on('click', function(e) {
        e.preventDefault();
        $(".lm-item-search:hidden").slice(0, 6).fadeIn();
        if ($(".lm-item-search:hidden").length == 0) {
            $("#load-more-search").hide();
        }
    });

    /*** Main Menu > Search ***/

    $('.nav-search .label').click(function() {
        if ($('.nav-search').hasClass('active')) {
            $('.nav-search').removeClass('active');
            $('.search-bar').hide();
        } else {
            $('.nav-search').addClass('active');
            $('.search-bar').show();
        }
        e.preventDefault();
    });
  	
  	//adding on enter functionality
  	$('.nav-search .label').on('keypress', function(e) {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode == '13') {
            $('.nav-search').addClass('active');
            $('.search-bar').show();
            e.preventDefault();
        }
    });
  
  	/*** Search Bar ***/

    $('header > #main-nav .search-bar .search button').on('click touchstart', function(e) {
        e.preventDefault();
        var input = $('header > #main-nav .search-bar .search form .input-search');
        var form = $('header > #main-nav .search-bar .search form');
        input.toggleClass('active');
        input.focus();
        if (input.val()) {
            input.addClass('active');
            form.submit();
        }
    });
    $('header > #main-nav .search-mobile-menu button').on('click touchstart', function(e) {
        e.preventDefault();
        var input = $('header > #main-nav .search-mobile-menu form .input-search');
        var form = $('header > #main-nav .search-mobile-menu form');
        if (input.val()) {
            form.submit();
        }
    });
  	//adding on enter functionality
    $('header > #main-nav .search-bar .search button').on('keypress', function(e) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '13') {
            e.preventDefault();
            var input = $('header > #main-nav .search-bar .search form .input-search');
            var form = $('header > #main-nav .search-bar .search form');
            input.toggleClass('active');
            input.focus();
            if (input.val()) {
                input.addClass('active');
                form.submit();
            }
        }
    });
  
  	/*** Main Menu > Country Selector ***/
  
  	//adding on enter functionality
    $('.nav-country .label').on('keypress', function(e) {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode == '13') {
            $('.nav-country').addClass('active');
            $('.countries').show();
            e.preventDefault();
        }
    });

    /*** Mobile Menu ***/

    $('.hamburger').click(function(e) {
        $('body').addClass('freeze');
        if ($(this).children('i').hasClass('fa-bars')) {
            $(this).children('i').removeClass('fa-bars');
            $(this).children('i').addClass('fa-times');
            $('.site-header').addClass('mobile-menu-open');
            $('.mobile-menu').slideDown();
        } else {
            $(this).children('i').addClass('fa-bars');
            $(this).children('i').removeClass('fa-times');
            $('.site-header').removeClass('mobile-menu-open');
            $('.mobile-menu').slideUp();
        }
        e.preventDefault();
    });
    $('.mobile-menu .has-children').click(function(e) {
        $(this).toggleClass('children-open');
        $(this).next('.sub-menu').slideToggle();
        e.preventDefault();
    });
    $('.mobile-menu .has-grandchildren').click(function(e) {
        $(this).toggleClass('children-open');
        $(this).next('.grandchild').slideToggle();
        e.preventDefault();
    });

    // Single Product Carousel

    if ($('#single-product').length) {
        $('.gallery-top').slick({
            infinite: true,
            arrows: true,
            prevArrow: '<i class="fa fa-angle-left slick-prev"></i>',
            nextArrow: '<i class="fa fa-angle-right slick-next"></i>'
        });
        $('.template.product .product_variants label').click(function() {
            $('.template.product .product_variants label').removeClass('active');
            $(this).addClass('active');
            var option_index = $(this).parent().index();
            $('.gallery-top').slick('slickGoTo', option_index);
            var thisVal = $(this).attr('data-value');
            $('.product-options option[value="' + thisVal + '"]').prop('selected', true);
            var newPrice = $(".product-options option:selected").attr('data-price');
            var oldPrice = $(".product-options option:selected").attr('data-orig');
            $('.new-price').text(newPrice);
            if (oldPrice) $('.old-price').text(oldPrice);
        });
        var selectedVariant = $('.template.product .product_variants label.active').parent().index();
        $('.gallery-top').slick('slickGoTo', selectedVariant);
    }
    if ($('.qty-input-group').length) {
        $(".qty-input-group button").on("click", function() {
            var $button = $(this);
            var oldValue = $button.parent().find("input").val();
            if ($button.hasClass('plus')) {
                var newVal = parseFloat(oldValue) + 1;
            } else {
                // Don't allow decrementing below zero
                if (oldValue > 1) {
                    var newVal = parseFloat(oldValue) - 1;
                } else {
                    newVal = 1;
                }
            }
            $button.parent().find("input").val(newVal);
        });
    }

    // My Account Section

    if ($('#AddressNewForm_toggle').length) {
        $('#AddressNewForm_toggle').on('click touchstart', function(e) {
            e.preventDefault();
            $('#AddressNewForm').slideToggle();
        });
    }
    if ($('.edit-address-toggle').length) {
        $('.edit-address-toggle').on('click touchstart', function(e) {
            e.preventDefault();
            $(this).next().next().slideToggle();
        });
    }
    if ($('#RecoverPassword').length) {
        $('#RecoverPassword').on('click touchstart', function(e) {
            e.preventDefault();
            $('#CustomerLoginForm').hide();
            $('#RecoverPasswordForm').show();
        });
        $('#HideRecoverPasswordLink').on('click touchstart', function(e) {
            e.preventDefault();
            $('#RecoverPasswordForm').hide();
            $('#CustomerLoginForm').show();
        });
    }
    if ($("#price-range-filter").length) {
        $("#price-range-filter").slider({
            tooltip: 'always'
        });
    }

    /*** MOBILE TWEAKS ***/

    var screenSmall = window.matchMedia('(max-width: 576px)');
    var screenMedium = window.matchMedia('(max-width: 768px)');
    var screenLarge = window.matchMedia('(max-width: 992px)');

    screenSmall.addListener(smResize);
    screenMedium.addListener(mdResize);
    screenLarge.addListener(lgResize);

    // Small
    function smResize(screenSmall) {
        if (screenSmall.matches) {}
    }
    smResize(screenSmall);

    // Medium
    function mdResize(screenMedium) {
        if (screenMedium.matches) {
            $('#add-address').click(function() {
                $(this).toggleClass('open');
                $('#AddressNewForm').slideToggle();
            });
            $('[data-toggle="search"]').click(function() {
                $('.search-toggle').slideToggle('fast');
                $('.search-toggle').find('.form-control').focus();
            });
            $('.dropdown').on('show.bs.dropdown', function(e) {
                $(this).find('.dropdown-menu').first().stop(true, true).slideDown(300);
            });
            $('.dropdown').on('hide.bs.dropdown', function(e) {
                $(this).find('.dropdown-menu').first().stop(true, true).slideUp(200);
            });
        }
    }
    mdResize(screenMedium);

    // Large
    function lgResize(screenLarge) {
        if (screenLarge.matches) {
            $('[data-toggle="offcanvas"]').click(function() {
                $('.row-offcanvas').toggleClass('active');
            });
        }
    }
    lgResize(screenLarge);

    /* ADA Compliance - iMedia */
    
    //Removing any classes and closing things when you hit esc
    /*
    $(document).on('keyup', function(e) {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode == '27') {
            $('.nav-search').removeClass('active');
            $('.search-bar').hide();
            $('.nav-country').removeClass('active');
            $('.countries').hide();
            if ( $('.main-left > ul > li.toggle-mega').hasClass('open') ) {
            	$('.main-left > ul > li:nth-child(2) > a').focus();
            	$('.main-left > ul > li.toggle-mega').removeClass('open');
            };
            $('.product-mega-menu').slideUp();
          	$('.main-left > ul > li').removeClass('open');
          	$('.main-right > ul > li').removeClass('open');
        };
    }); */
});